
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoardVisible"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Board"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visible"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":45}};
    doc.loc.source = {"body":"fragment BoardVisible on Board {\n  visible\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/BoardVisibleFragment.graphql
// module id = BztP
// module chunks = 1